export default function Footer() {
  return (
    <footer className="bg-[#0A1F44]">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-10 py-6">
        <p className="text-white/50 text-sm text-center">
          © 2026 nexaur<span style={{ color: '#991B1B' }}>A</span> <span style={{ color: '#991B1B' }}>I</span>nfinity. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
